var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row col-10"},_vm._l((_vm.txtContent),function(item){return _c('div',[(item.type == _vm.wlPlanType)?_c('pre',[_vm._v("      "),_c('p',[_c('i',{class:item.icon,staticStyle:{"padding-right":"5px"}}),_c('b',[_vm._v(_vm._s(item.title)+":")]),_vm._v(_vm._s(item.content))]),_vm._v("\n  ")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }